import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/serverError";

export default class CommonStore {

    darkMode: boolean = false;
    error: ServerError | null = null;
    token: string | null = window.localStorage.getItem('jwt');
    appLoaded: boolean = false;

    constructor() {
        makeAutoObservable(this);
        reaction(
            () => this.token, // this is what we are reacting to
            token => {
                if (token) window.localStorage.setItem('jwt', token)
                else window.localStorage.removeItem('jwt')
            }
        )        
    }

    get darkModeEnabled() {
        return this.darkMode;
    }

    setServerError = (error: ServerError) => {
        this.error = error;
    }

    setToken = (token: string | null) => {
        this.token = token;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }

    toggleDarkMode = () => {
        this.darkMode = !this.darkMode;
    }
}